<!-- Header -->
<div class="header">
  <h2 mat-dialog-title class="mat-title">
    <span >{{'COMPANY_DETAILS_HEADER.remove_users' | translate}}</span>
    <span class="close-dialog" (click)="close()">&#10006;</span>
  </h2>
</div>
<mat-dialog-content>
  <p>{{"Delete_Users_Title_1" | translate}}{{data?.appName}}{{"Delete_Users_Title_2" | translate}}</p>
  <div>
   @for (user of data?.users; track user) {
   <ul>
    <li><strong>{{ user?.name }}</strong></li>
    </ul>
   }
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button color="primary" mat-button="" mat-dialog-close>{{"COMPANY_ADD_USERS.cancel" | translate}}</button>
  <button mat-raised-button color="primary" [mat-dialog-close]="true">{{ 'Remove' | translate }}</button>
</mat-dialog-actions>
